import React from 'react';
import { styled } from '../../../stitches.config';
import { Parallax, Background } from 'react-parallax';
import LazyLoad from "react-lazyload";

import Html from './Html';
import KulkiSvgExtra from '../../common/KulkiSvgExtra';

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"
// bizon
import { useStores } from '../../../helpers';


const BackgroundImage = ({ blockData, type, ...props }) => {
    const windowWidth = window.innerWidth;
    const { ArticleStore } = useStores();
    const { isParallax, hasOverlay = false, hasTextShadow = false, backgroundTextTop, backgroundTextBottom, backgroundUrl = "", author, category, imageCaption } = blockData;
    const isAuthor = !!author;
    const urlWidth = window.innerWidth < 996 ? 960 : 1920;
    const srcUrl = backgroundUrl.replace("0,0,0,0", `${urlWidth},0,0,0`);

    const { isFirst = false } = props;

    const video = (
        <>
            {isFirst ?
                <div style={{ aspectRatio: '16 / 9', transform: 'scale(1.05)' }}>
                    <video muted loop autoPlay playsInline onLoadedData={() => props.updateHeight()}>
                        <source src={backgroundUrl} type="video/mp4" />
                    </video>
                    <div className="overlay" />
                </div>
                :
                <LazyLoad once={true} offset={600} placeholder={<div style={{ aspectRatio: '16 / 9', transform: 'scale(1.05)' }} />}>
                    <video muted loop autoPlay playsInline onLoadedData={() => props.updateHeight()}>
                        <source src={backgroundUrl} type="video/mp4" />
                    </video>
                    <div className="overlay" />
                </LazyLoad>
            }
        </>
    )

    const ext = srcUrl.substring(srcUrl.lastIndexOf('.') + 1);
    const srcUrlWebp = srcUrl.replace(`.${ext}`, ".webp");
    const imageSet = `image-set(
        url("${srcUrlWebp}") type("image/webp"),
        url("${srcUrl}") type("image/${ext}")
    )`;

    if (type === 'background_video') {
        return <Wrapper primary={isAuthor}>
            <BizonBackgroundTextTop hasTextShadow={hasTextShadow}>
                <Html html={backgroundTextTop} />
            </BizonBackgroundTextTop>
            <BgWrapper primary={isAuthor} parallax={isParallax} hasOverlay={hasOverlay}>
                <WithParallax parallax={isParallax} strength={window.innerWidth > 996 ? 700 : 100}>
                    {isParallax ? <Background>
                        {video}
                    </Background> : video}
                    <VidWrapper parallax={isParallax}>

                        <BizonBackgroundVideoTextBottom hasTextShadow={hasTextShadow}>
                            <Html pageHeader={true} html={backgroundTextBottom} />
                        </BizonBackgroundVideoTextBottom>
                    </VidWrapper>
                </WithParallax>
            </BgWrapper>
        </Wrapper>
    }
    return <Wrapper primary={isAuthor}>
        <BizonBackgroundTextTop hasTextShadow={hasTextShadow}>
            <Html html={backgroundTextTop} />
        </BizonBackgroundTextTop>
        <BgWrapper primary={isAuthor} hasOverlay={hasOverlay}>
            <WithParallax parallax={isParallax} backgroundUrl={srcUrl} strength={500}>
                <BackgroundImg
                    css={{ "$$src": imageSet }}
                    primary={isAuthor} parallax={isParallax} hasOverlay={hasOverlay}>
                    <BackgroundGradient className="rich-article-background-img" primary={isAuthor} />
                    <BizonBackgroundTextBottom hasTextShadow={hasTextShadow}>
                        {backgroundTextBottom && <Category>{ArticleStore.fetchedArticle.article.category.name}</Category>}
                        <Html pageHeader={true} html={backgroundTextBottom} />
                    </BizonBackgroundTextBottom>
                </BackgroundImg>
            </WithParallax>
            {imageCaption !== "" && <BizonImageCaption>{imageCaption}</BizonImageCaption>}
        </BgWrapper>
    </Wrapper>
}

const WithParallax = ({ parallax, backgroundUrl, strength = 100, children }) => {
    return parallax ? <Parallax
        strength={strength}
        bgImage={backgroundUrl}
    >
        {children}
    </Parallax>
        : <div style={{ overflow: "hidden" }}>
            {children}
        </div>

}

const VidWrapper = styled("div", {
    variants: {
        "parallax": {
            true: {
                minHeight: "150px",
                "@bp4": {
                    minHeight: "500px"
                }
            },
            false: {}
        }
    }
});

const Category = styled("div", {
    padding: "2px 4px 2px 18px",
    color: "white",
    backgroundColor: "$primary",
    fontFamily: "$grotesk !important",
    fontSize: "12px !important",
    fontWeight: "800 !important",
    lineHeight: "16px !important",
    letterSpacing: "0.8px !important",
    marginBottom: "12px !important",
    maxWidth: "fit-content",
    position: "relative",
    "@bp4": {
        padding: "4px 8px 4px 18px",
        marginBottom: "16px !important"
    },
    "&:after": {
        position: "absolute",
        left: "7.5px",
        top: "6px",
        backgroundColor: "white",
        borderRadius: "5px",
        width: "5px",
        height: "5px",
        content: '" "'
    },
    "&:before": {
        position: "absolute",
        left: "7.5px",
        top: "13.5px",
        backgroundColor: "white",
        borderRadius: "5px",
        width: "5px",
        height: "5px",
        content: " "
    }
});

const BgWrapper = styled("div", {
    position: "relative",
    video: {
        width: "100vw",
        height: "auto",
        transform: "scale(1.05)"
    },
    "video ~ .overlay": {
        content: '""',
        position: "absolute",
        top: "0",
        right: "0",
        left: "0",
        bottom: "0",
        zIndex: 1,
        backgroundColor: "black",
        opacity: 0
    },
    "@media (min-width: 992px)": {
        video: {
            width: "100vw",
            height: "auto",
            transform: "scale(1)"
        },
        "video ~ .overlay": {
            bottom: "6px"
        }
    },
    variants: {
        hasOverlay: {
            true: {
                "video ~ .overlay": {
                    opacity: 0.4
                },
                ".react-parallax-content": {
                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                }
            },
            false: {}
        }
    }
});
const Wrapper = styled("div", {
    position: "relative",
    margin: "30px 0",
    "br": {
        display: "none"
    },
    "@media (min-width: 992px)": {
        margin: "75px 0",
        br: {
            display: "inline"
        }
    },
    variants: {
        primary: {
            true: {
                margin: "0 0 30px 0",
                "@media (min-width: 992px)": {
                    margin: "0 0 75px 0"
                }
            },
            false: {}
        }
    }
});

export const ImageCaption = styled("p", {
    margin: "3px 10px",
    fontSize: "10px",
    textAlign: "left",
    fontStyle: "italic",
    color: "#8b8b8b"
    /* position: absolute; */
});
export const BizonImageCaption = styled("p", {
    marginTop: "8px",
    fontStyle: "normal",
    textAlign: "center",
    color: "#8d8d8d",
    fontSize: "14px",
    lineHeight: "18px",
    fontFamily: "$grotesk",
    "@bp4": {
        marginTop: "12px"
    }
});

const BackgroundImg = styled("div", {
    paddingTop: "55%",
    position: "relative",
    width: "100%",
    backgroundSize: "cover",
    variants: {
        "primary": {
            true: {
                paddingTop: "92vh",
                "@media (min-width: 992px)": {
                    paddingTop: "100vh"
                }
            },
            false: {}
        },
        "hasOverlay": {
            true: {
                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))`,
                backgroundSize: "cover",
            },
            false: {}
        },
        "parallax": {
            true: {},
            false: {
                background: "$$src center no-repeat",
                backgroundSize: "cover",
            }
        }
    },
    compoundVariants: [
        {
            hasOverlay: true,
            parallax: false,
            css: {
                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), $$src center no-repeat`,
                backgroundSize: "cover",
            }
        }
    ]
});

const BackgroundGradient = styled("div", {
    position: "absolute",
    width: "100%",
    backgroundSize: "cover",
    top: 0,
    "@media (min-width: 992px)": {
        paddingTop: "55%"
    },
    variants: {
        "primary": {
            true: {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 0.85))`,
                paddingTop: "92vh",
                "@media (min-width: 992px)": {
                    paddingTop: "100vh"
                },
            },
            false: {}
        }
    }
});

const BackgroundText = styled("div", {
    left: "15%",
    margin: "0",
    zIndex: 2,
    letterSpacing: "-0.6px",
    a: {
        color: "rgb(255, 102, 0) !important",
        "&:hover": {
            textDecoration: "none"
        }
    },
    "span, .cdx-color": {
        color: "#ffffff"
    },
    variants: {
        hasTextShadow: {
            true: {
                textShadow: "-1px -1px #000"
            },
            false: {}
        }
    }
});

const BizonBackgroundTextTop = styled(BackgroundText, {
    position: "absolute",
    left: "26px",
    top: "15%",
    "& > div": {
        fontWeight: 700,
        color: "#131212",
        background: "white",
        fontFamily: "$grotesk",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0.2px",
        display: "inline-block",
        "@bp4": {
            fontSize: "54px",
            lineHeight: "72px",
            letterSpacing: "-0.5px"
        }
    },
    "span, .cdx-color": {
        color: "#131212",
        background: "white"
    },
    "@bp4": {
        left: "86px",
        width: "70%"
    }
});

const BizonBackgroundTextBottom = styled(BackgroundText, {
    position: "absolute",
    left: "26px",
    right: "0",
    margin: "0",
    bottom: "24px",
    "& > div": {
        top: "0",
        width: "100%",
        margin: "0",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0.2px",
        fontFamily: "$grotesk",
        fontWeight: 700,
        "@bp4": {
            fontSize: "54px",
            lineHeight: "72px",
            letterSpacing: "-0.5px"
        }
    },
    "& > h1": {
        top: "0",
        width: "100%",
        margin: "0",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0.2px",
        fontFamily: "$grotesk",
        fontWeight: 700,
        "@bp4": {
            fontSize: "54px",
            lineHeight: "72px",
            letterSpacing: "-0.5px"
        }
    },
    "span, .cdx-color": {
        color: "#131212",
        background: "white"
    },
    "@bp4": {
        left: "86px",
        bottom: "88px",
        width: "70%",
        minHeight: "20%"
    }
});

const BizonBackgroundVideoTextBottom = styled(BackgroundText, {
    marginTop: "24px",
    padding: "0 38px",
    "@bp4": {
        marginTop: "0px",
        padding: "0px",
        position: "absolute",
        left: "86px",
        bottom: "88px",
        width: "70%",
        minHeight: "20%"
    },
    "& > div": {
        top: "0",
        width: "100%",
        margin: "0",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0.2px",
        fontFamily: "$grotesk",
        fontWeight: 700,
        "@bp4": {
            fontSize: "54px",
            lineHeight: "72px",
            letterSpacing: "-0.5px"
        }
    },
    "& > h1": {
        top: "0",
        width: "100%",
        margin: "0",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0.2px",
        fontFamily: "$grotesk",
        fontWeight: 700,
        "@bp4": {
            fontSize: "54px",
            lineHeight: "72px",
            letterSpacing: "-0.5px"
        }
    },
    "span, .cdx-color": {
        color: "#131212",
        "@bp4": {
            background: "white"
        }
    }
});

export default withDrawingBoard(props => props.blockData.hasCanvas)(BackgroundImage);